import React from 'react';
import Switch from "components/elements/form/switch";
import Button from "components/elements/Button";
import { localIcon } from "components/elements/Icon";
import useRouter from "components/hooks/useRouter";
import useTrans from "components/hooks/useTrans";
import Link from "components/base/Link";
import cn from "classnames";
import { ItemPrice, Tier } from "components/pricing/calculator/Calculator_v2";
import { formatNumberToLocale, getCurrencySign } from "helpers";
import SwitchContainer from "components/pricing/calculator/SwitchContainer";
import SwitchOption from "components/pricing/calculator/SwitchOption";

type Props = {
    selectedTier: Tier;
    period: string;
    setPeriod: any;
    currency: string;
};

export default function Price_v2(props: Props) {
    const { selectedTier, setPeriod, period, currency } = props;
    const { locale } = useRouter();
    const { t } = useTrans();

    const textAroundPriceCn = cn(
        "font-semibold text-sm lg:text-xs text-gray-500"
    );

    const textAroundSwitchCn = cn(
        "text-gray-700 font-light lg:font-normal text-base lg:items-center lg:flex"
    );

    return (
        <div className={"lg:flex lg:flex-col lg:w-4/12 lg:pl-10 justify-between lg:relative"}>
            <SwitchContainer numberOfChildren={2} selectedIndex={period === "month" ? 0 : 1}>
                <SwitchOption isSelected={period === "month"} onClick={() => setPeriod("month")} numberOfChildren={2}>
                    {t('monthly')}
                </SwitchOption>
                <SwitchOption isSelected={period === "year"} onClick={() => setPeriod("year")} numberOfChildren={2}>
                    <div className={"flex flex-col"}>
                            <span
                                className={`text-center text-sm ${period === "year" ? "font-medium" : "text-gray-500"}`}
                            >
                                {t('yearly')}
                            </span>
                        <span className={"text-center text-xs text-gray-400"}>
                                {t('tenPercentDiscount')}
                            </span>
                    </div>
                </SwitchOption>
            </SwitchContainer>
            {selectedTier.displayPricePerMonth[currency] &&
                <div
                    className={"mb-8 text-center lg:text-left lg:inset-y-0 lg:left-4"}
                >
                    <div className={"flex justify-center lg:justify-start"}>
                        <span
                            className={"text-5xl font-medium"}
                        >{period === "year" ? selectedTier.displayPricePerMonth[currency] : selectedTier.displaySimplePrice[currency]}</span>
                    </div>
                    <div>
                        <span className={textAroundPriceCn}>
                            {t('priceAmonthBasedOnContacts', {
                                contacts: selectedTier.displayQuantity[currency],
                                periodUnit: t('month')
                            })}
                        </span>
                    </div>
                    {period === "year" &&
                        <div className={'text-md pt-2 lg:flex'}>
                            <span
                                className={"font-light text-primary-400"}
                                dangerouslySetInnerHTML={{
                                    __html: t("billedAtYearly", {
                                        fullPrice: selectedTier.displayFullPrice[currency],
                                        price: selectedTier.displayPrice[currency],
                                    }),
                                }}
                            />
                        </div>
                    }
                </div>
            }
            <div className={'mb-10 lg:mb-8'}>
                <Link to={'/demo-request'}>
                    <Button
                        id="pricing-calculator__start-now"
                        variant={"primary"}
                        size={"large"}
                        color={"purple"}
                        icon={localIcon("chevron-right", "bg-white")}
                        className={"w-full justify-center"}
                    >
                        {t('startNow')}
                    </Button>
                </Link>
            </div>
        </div>
    );
}